import type {
    IBaseSubChartProperty,
} from '@src/slide/domain/ui-model/element-modeles/property/chart/sub-chart/base-sub-chart.interface';
import type { STOfPieType, STSplitType } from '../../../Interface/chart-v3/sdk-model.interface';
import { IDataItemProperty } from './data-item/data-item.interface';
import { IDataLabelProperty } from './data-label/data-label.interface';

export interface IOfPieChartProperty extends
    IBaseSubChartProperty
{
    parentOtherData: IDataItemProperty;
    childDefaultData: IDataItemProperty;
    ofPieType: STOfPieType;
    splitType: STSplitType;
    gapWidth: number;   // 100
    secondPieSize: number;  // 75
    splitPos: number; // 0
    secondPiePts: number[];
    generateOtherLabel: (
        dataItem: IDataItemProperty,
        tempData: IDataItemProperty,
        extra?: {  tempData: IDataItemProperty, parentTotal: number, childTotal: number },
    ) => IDataLabelProperty
}


export const DEFAULT_CATEGORY = 'child_total_category';
export const DEFAULT_CHILD_FILL = '#404040';
export const DEFAULT_CHILD_BORDER = '#000000';
export const DEFAULT_CHILD_VALUE = 100;
